import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200 } from '@fukuri-admins/apis/client/gen/model';
import { parseISO } from 'date-fns';
import type { EditClientContractTermFormValues } from '../schema';

type Args = {
  /** API レスポンス（useFetch の data をそのまま受け取る） */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsId200;
};

type IConvertToFormValues = (args: Args) => EditClientContractTermFormValues;

/**
 * 企業契約期間データをフォームの初期値に変換する
 *
 * - data.client_contract から単一の契約期間を受け取る
 * - clientId を追加（SelectFieldController name='clientId' が react-hook-form Context を要求するため）
 * - started_on（'YYYY-MM-DD' 文字列）は parseISO でローカル時刻の Date に変換（DatePicker 用）
 * - ended_on（'YYYY-MM-DD' 文字列 / null）も同様に変換。null（無期限）はそのまま null で保持
 * - InternalAdmin 版（apps/internal/src/features/EditPartnerClientContract/logics/convertToFormValues/）と実装パターンを揃える
 */
export const convertToFormValues: IConvertToFormValues = ({ data }) => {
  const contractTerm = data.client_contract;

  return {
    clientId: String(contractTerm.client.id),
    contractPlanId: String(contractTerm.contract_plan.id),
    startedOn: parseISO(contractTerm.started_on),
    endedOn: contractTerm.ended_on ? parseISO(contractTerm.ended_on) : null,
  };
};
